export const provinces = [
  {
    name: 'Azua',
    municipalities: ['Azua', 'Estebanía', 'Guayabal', 'Las Charcas', 'Las Yayas de Viajama', 'Padre Las Casas', 'Peralta', 'Pueblo Viejo', 'Sabana Yegua', 'Tábara Arriba']
  },
  {
    name: 'Bahoruco',
    municipalities: ['Galván', 'Los Ríos', 'Neiba', 'Tamayo', 'Villa Jaragua']
  },
  {
    name: 'Barahona',
    municipalities: ['Barahona', 'Cabral', 'El Peñón', 'Enriquillo', 'Fundación', 'Jaquimeyes', 'La Ciénaga', 'Las Salinas', 'Paraíso', 'Polo', 'Vicente Noble']
  },
  {
    name: 'Dajabón',
    municipalities: ['Dajabón', 'El Pino', 'Loma de Cabrera', 'Partido', 'Restauración']
  },
  {
    name: 'Distrito Nacional',
    municipalities: ['Distrito Nacional']
  },
  {
    name: 'Duarte',
    municipalities: ['Arenoso', 'Castillo', 'Hostos', 'Las Guáranas', 'Pimentel', 'San Francisco de Macorís', 'Villa Riva']
  },
  {
    name: 'Elías Piña',
    municipalities: ['Bánica', 'Comendador', 'El Llano', 'Hondo Valle', 'Juan Santiago', 'Pedro Santana']
  },
  {
    name: 'El Seibo',
    municipalities: ['El Seibo', 'Miches']
  },
  {
    name: 'Espaillat',
    municipalities: ['Cayetano Germosén', 'Gaspar Hernández', 'Jamao Al Norte', 'Moca', 'San Víctor']
  },
  {
    name: 'Hato Mayor',
    municipalities: ['El Valle', 'Hato Mayor', 'Sabana de la Mar']
  },
  {
    name: 'Hermanas Mirabal',
    municipalities: ['Salcedo', 'Tenares', 'Villa Tapia']
  },
  {
    name: 'Independencia',
    municipalities: ['Cristóbal', 'Duvergé', 'Jimaní', 'La Descubierta', 'Mella', 'Postrer Río']
  },
  {
    name: 'La Altagracia',
    municipalities: ['Higüey', 'San Rafael del Yuma']
  },
  {
    name: 'La Romana',
    municipalities: ['Guaymate', 'La Romana', 'Villa Hermosa']
  },
  {
    name: 'La Vega',
    municipalities: ['Constanza', 'Jarabacoa', 'Jima Abajo', 'La Vega']
  },
  {
    name: 'María Trinidad Sánchez',
    municipalities: ['Cabrera', 'El Factor', 'Nagua', 'Río San Juan']
  },
  {
    name: 'Monseñor Nouel',
    municipalities: ['Bonao', 'Maimón', 'Piedra Blanca']
  },
  {
    name: 'Monte Cristi',
    municipalities: ['Castañuelas', 'Guayubín', 'Las Matas de Santa Cruz', 'Monte Cristi', 'Pepillo Salcedo', 'Villa Vásquez']
  },
  {
    name: 'Monte Plata',
    municipalities: ['Bayaguana', 'Monte Plata', 'Peralvillo', 'Sabana Grande de Boyá', 'Yamasá']
  },
  {
    name: 'Pedernales',
    municipalities: ['Oviedo', 'Pedernales']
  },
  {
    name: 'Peravia',
    municipalities: ['Baní', 'Matanzas', 'Nizao']
  },
  {
    name: 'Puerto Plata',
    municipalities: ['Altamira', 'Guananico', 'Imbert', 'Los Hidalgos', 'Luperón', 'Puerto Plata', 'Sosúa', 'Villa Isabela', 'Villa Montellano']
  },
  {
    name: 'Samaná',
    municipalities: ['Las Terrenas', 'Samaná', 'Sánchez']
  },
  {
    name: 'San Cristóbal',
    municipalities: ['Cambita Garabitos', 'Haina', 'Los Cacaos', 'Nigua', 'Sabana Grande de Palenque', 'San Cristóbal', 'Villa Altagracia', 'Yaguate']
  },
  {
    name: 'San José de Ocoa',
    municipalities: ['Rancho Arriba', 'Sabana Larga', 'San José de Ocoa']
  },
  {
    name: 'San Juan',
    municipalities: ['Bohechío', 'El Cercado', 'Juan de Herrera', 'Las Matas de Farfán', 'San Juan', 'Vallejuelo']
  },
  {
    name: 'San Pedro de Macorís',
    municipalities: ['Consuelo', 'Guayacanes', 'Los Llanos', 'Quisqueya', 'Ramón Santana', 'San Pedro de Macorís']
  },
  {
    name: 'Sánchez Ramírez',
    municipalities: ['Cevicos', 'Cotuí', 'Fantino', 'La Mata']
  },
  {
    name: 'Santiago',
    municipalities: ['Baitoa', 'Jánico', 'Licey al Medio', 'Puñal', 'Sabana Iglesia', 'San José de las Matas', 'Santiago de los Caballeros', 'Tamboril', 'Villa Bisonó (Navarrete)', 'Villa González']
  },
  {
    name: 'Santiago Rodríguez',
    municipalities: ['Monción', 'Sabaneta', 'Villa Los Almácigos']
  },
  {
    name: 'Santo Domingo',
    municipalities: ['Boca Chica', 'La Caleta', 'La Victoria', 'Los Alcarrizos', 'Pedro Brand', 'San Antonio de Guerra', 'Santo Domingo Este', 'Santo Domingo Norte', 'Santo Domingo Oeste']
  },
  {
    name: 'Valverde',
    municipalities: ['Esperanza', 'Laguna Salada', 'Mao']
  }
];
